export default "__VITE_ASSET__6b307e4e__"